module.exports = __webpack_public_path__ + "static/media/WST2.98f3e574.apng";